// Charge la base commune
import './common.js'

// Styles custom
import './scss/pages/models.detail.scss'

// Responsive Tabs
async function getRTabs () {
  import(/* webpackChunkName: "responsiveTabs" */ './js/components/responsiveTabs.js').then(() => {
    /* global Waypoint */
    Waypoint.refreshAll()
  })
}

// MasterSlider
async function getMasterSlider () {
  import(/* webpackChunkName: "masterSlider", webpackPrefetch: true */ './js/components/masterSlider.js').then(() => {
    Waypoint.refreshAll()
  })
}

// Gallery
async function getPhotoswipe () {
  import(/* webpackChunkName: "photoswipe", webpackPrefetch: true */ './js/components/photoswipe.js').then(() => {
    Waypoint.refreshAll()
  })
}

// ModelLike
async function getModelLike ($add) {
  import(/* webpackChunkName: "modelLike" */ './js/components/modelLike.js').then(module => {
    module.modelLike.init()
    $add.trigger('click')
  })
}

// Agencies Search Form
async function getAsForm ($f) {
  import(/* webpackChunkName: "agenciesSearchForm" */ './js/components/agenciesSearchForm.js').then(() => {
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// Contact Form
async function getCForm ($f) {
  import(/* webpackChunkName: "contactForm" */ './js/components/contactForm.js').then(() => {
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// Agency autocomplete
async function getAgenciesAutocomplete ($f) {
  import(/* webpackChunkName: "agenciesAutocomplete" */ './js/components/agenciesAutocomplete.js').then(module => {
    module.agenciesAutocomplete.init($f)
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // responsive tabs
  $('#desc-tabs').waypoint(function () {
    getRTabs()
    this.destroy()
  }, {
    offset: '100%'
  })

  // gestion master slider
  const $m = $('#masterslider')
  if ($m.length) {
    $m.waypoint(function () {
      getMasterSlider()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion des galeries
  const $g = $('.gallery')
  if ($g.length) {
    $g.waypoint(function () {
      getPhotoswipe()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // boutons d'action sur le modèle détaillé
  $('#like').on('click', function () {
    getModelLike($(this))
  })
  if (typeof (googleanalytics) !== 'undefined') {
    $('#track-f').on('click', function () { // event sur bouton financement : track event google analytics
      /* global ga */
      ga('send', 'event', 'Financement modele', 'Clic')
      /* global gtag */
      if (typeof (googletag) !== 'undefined') { gtag('event', 'financing', { element: 'model' }) }
    })
    $('#track-c, #track-c2').on('click', function () { // event sur bouton contact : track event google analytics
      ga('send', 'event', 'Contacter modele', 'Clic')
      if (typeof (googletag) !== 'undefined') { gtag('event', 'contact', { subject: 'model' }) }
    })
    $('#track-g').on('click', function () { // event sur bouton terrain
      ga('send', 'event', 'Recherche terrain', 'Clic')
      if (typeof (googletag) !== 'undefined') { gtag('event', 'find_ground') }
    })
  }

  // formulaire de contact
  const $f = $('form[name="cForm"]')
  $f.waypoint(function () {
    $f.load()
    getCForm($f)
    this.destroy()
  }, {
    offset: '100%'
  })

  // gestion de la recherche d'agences la plus proche
  const $c = $('form[name="asForm"]')
  if ($c.length) {
    $c.waypoint(function () {
      $c.load()
      getAsForm($c)
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // filtres des agences autocomplete
  $('form[name="asForm"] input[name="location"]').on('click keyup focus', function () {
    $(this).blur().off().attr('disabled', '').val('Veuillez patienter...')
    getAgenciesAutocomplete($(this).parents('form'))
  })
})
